import React from 'react';
import { FaBox } from 'react-icons/fa';
import { CLIENT_CATALOG } from '../../constant';
import PageHeader from '../PageHeader/PageHeader';

export default function ClientCatalogPageHeader() {
  return (
    <PageHeader
      icon={<FaBox size={22} />}
      title={CLIENT_CATALOG.PAGE_TITLE}
      subtitle={CLIENT_CATALOG.PAGE_SUBTITLE}
    />
  );
}
